import { render, staticRenderFns } from "./CustomPermission.vue?vue&type=template&id=335350f6&scoped=true&"
import script from "./CustomPermission.vue?vue&type=script&lang=js&"
export * from "./CustomPermission.vue?vue&type=script&lang=js&"
import style0 from "./CustomPermission.vue?vue&type=style&index=0&id=335350f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335350f6",
  null
  
)

export default component.exports